<div class="template-card" [class.selected]="template.selected">
  <div class="template-preview">
    <img [src]="template.image" [alt]="template.name" class="template-image">
  </div>
  
  <div class="template-info">
    <h3 class="template-name">{{ template.name }}</h3>
    <p class="template-pages">{{ template.pages }} Pages</p>
  </div>
  
  <!-- Buttons that appear on hover -->
  <div class="template-buttons">
    <app-action-button
      buttonText=""
      variant="secondary"
      size="medium"
      [iconSrc]="eyeIconSrc"
      (buttonClick)="onPreview()"
      [disabled]="isLoading"
      ariaLabel="Preview template">
    </app-action-button>
    <button 
      class="btn-apply"
      [disabled]="isLoading"
      (click)="onApply()">
      <svg *ngIf="isLoading" class="spinner" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1.5V4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M8 11.5V14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.3"/>
        <path d="M3.75 3.75L5.81 5.81" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.9"/>
        <path d="M10.19 10.19L12.25 12.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.2"/>
        <path d="M1.5 8H4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.8"/>
        <path d="M11.5 8H14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.4"/>
        <path d="M3.75 12.25L5.81 10.19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.7"/>
        <path d="M10.19 5.81L12.25 3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
      </svg>
      <span *ngIf="!isLoading">Apply Template</span>
      <span *ngIf="isLoading">Applying...</span>
    </button>
  </div>
</div>
